export const UPDATE_AJAX_LOADING = 'UPDATE_AJAX_LOADING'
export const CLEAR_LIST = 'CLEAR_LIST'
export const SET_ASCENDANT = 'SET_ASCENDANT'
export const SET_PAGE = 'SET_PAGE'
export const SET_SORT_BY = 'SORT_BY'
